import styled from 'styled-components'

export const GroupsListContainer = styled.div`
    padding: 24px 20px 0;
    @media (min-width: 992px) {
        width: 750px;
        width: 970px;
    }
    @media (min-width: 1600px) {
        width: 1170px;
    }

    .groups-list-search {
        display: flex;
        margin-bottom: 24px;
    }
    .no-group {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 64px;

        p {
            padding-top: 5px;
            color: var(--gray-700);
            font-size: 13px;
        }

        i {
            color: var(--gray-500);
            font-size: 24px;
        }

        a {
            color: var(--blue-500);
            font-size: 13px;
        }

        .fa-trash-alt {
            color: ${({ theme }) => theme['red-700']};
        }
    }
`
